<template>
	<!-- 课题申报书内容 -->
	<div class="content">
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<h4 class="header-title mb-3">第三步：课题申报书内容</h4>

						<div class="card-newProject">
							<!-- 表单 -->
							<el-form :model="notificationForm" :rules="notificationFormRules" ref="notificationFormRef" label-width="110px" class="demo-notificationForm">
								<h3 class="text-center">上传课题申报书内容</h3>
								<el-form-item label="申报书内容" prop="declarationContents">
									<el-upload
										class="upload-demo"
										ref="upload1"
										:action="uploadUrl + '/upload/uploadToLocal'"
										multiple
										accept=".doc,.docx"
										:limit="1"
										:show-file-list="false"
										:before-remove="beforeRemove1"
										:on-success="uploadSuccess1"
										:on-preview="preview1"
										:before-upload="beforeAvatarUpload1"
									>
										<el-button size="small" type="primary">点击上传</el-button>
										<div @click="preview1" class="uploaded-file" v-if="Object.keys(declarationContents).length">
											<div class="ellipsis">{{ declarationContents.name }}</div>
											<i @click.stop="delFile1" class="icon el-icon-circle-close"></i>
										</div>
										<div slot="tip" class="el-upload__tip">(限doc,docx格式)*</div>
									</el-upload>
								</el-form-item>

								<template v-if="projectData && projectData.anonymousReviewState == 1">
									<h3 class="text-center">上传匿名评审活动</h3>
									<p class="text-center text-danger m-0">说明：用于专家匿名评审，不能出现学校名称和相关人名。</p>
									<el-form-item label="匿名评审活页" prop="anonymousReview">
										<el-upload
											class="upload-demo"
											ref="upload2"
											:action="uploadUrl + '/upload/uploadToLocal'"
											accept=".doc,.docx"
											multiple
											:limit="1"
											:show-file-list="false"
											:before-remove="beforeRemove2"
											:on-success="uploadSuccess2"
											:on-preview="preview2"
											:before-upload="beforeAvatarUpload2"
										>
											<el-button size="small" type="primary">点击上传</el-button>
											<div @click="preview2" class="uploaded-file" v-if="Object.keys(anonymousReview).length">
												<div class="ellipsis">{{ anonymousReview.name }}</div>
												<i @click.stop="delFile2" class="icon el-icon-circle-close"></i>
											</div>
											<div slot="tip" class="el-upload__tip">(限doc,docx格式)*</div>
										</el-upload>
									</el-form-item>
								</template>
								<div class="text-center">
									<el-button size="small" type="primary" @click="preStep">上一步</el-button>
									<el-button size="small" type="primary" @click="submit">保存并提交</el-button>
								</div>
							</el-form>
						</div>
					</div>
					<!-- end card-body-->
				</div>
				<!-- end card -->
			</div>
			<!-- end col-->
		</div>
	</div>
</template>

<script>
import { addOrEditTopicsDeclaration } from '@/api/after/projectApplication.js';
export default {
	props: {
		projectApplicationId: {
			type: String | Number,
			default: ''
		},
		topicDetail: {
			type: Object,
			default: null
		},
		oneStepIsFinish: {
			type: Boolean,
			default: false
		},
		twoStepIsFinish: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		topicDetail: {
			handler(newVal) {
				if (newVal.declarationContents) {
					this.notificationForm.declarationContents = newVal.declarationContents;
					this.declarationContents = {
						name: newVal.declarationContentsName,
						fileId: newVal.declarationContents
					};
				}
				if (newVal.anonymousReview) {
					this.notificationForm.anonymousReview = newVal.anonymousReview;
					this.anonymousReview = {
						name: newVal.anonymousReviewName,
						fileId: newVal.anonymousReview
					};
				}
			},
			deep: true
		}
	},
	data() {
		return {
			projectData: {},
			notificationForm: {
				declarationContents: '', //申报书内容附件
				anonymousReview: '' //匿名评审活页
			},
			notificationFormRules: {
				declarationContents: [{ required: true, message: '请上传申报书内容', trigger: 'change' }],
				anonymousReview: [{ required: true, message: '请上传匿名评审活页', trigger: 'change' }]
			},
			declarationContents: {}, //申报书内容附件
			anonymousReview: {} //匿名评审活页
		};
	},
	created() {
		this.projectData = JSON.parse(sessionStorage.getItem('projectData'));
		// 如果匿名评审文件不用传,把匿名评审文件变为非必传
		if (this.projectData.anonymousReviewState == 0) {
			this.notificationFormRules.anonymousReview[0].required = false;
		}
	},
	methods: {
		// 提交表单
		submit() {
			if (!this.oneStepIsFinish) {
				this.$message.warning('请先完成课题基本信息！');
				return;
			}
			if (!this.twoStepIsFinish) {
				this.$message.warning('请先完成负责人及成员信息！');
				return;
			}

			console.log('附件', this.notificationForm);
			this.$refs.notificationFormRef.validate(async valid => {
				if (valid) {
					this.notificationForm.projectId = this.$route.query.projectId;
					if (this.projectApplicationId) {
						this.notificationForm.id = this.projectApplicationId;
					}
					this.notificationForm.projectNumber = 3;

					const res = await addOrEditTopicsDeclaration(this.notificationForm);
					if (res.code == 200) {
						this.$alert('您的课题已申报完成，请等待学校和区级管理部门的审批，请及时登录系统查看审核结果！', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								this.$router.go(-1);
							}
						});
					} else {
						this.$message.error(res.data);
					}
				} else {
					this.$message.error('请完成表单');
				}
			});
		},
		// 上一步
		preStep() {
			this.$emit('preStep', this.projectApplicationId);
		},
		beforeRemove1(file, fileList) {
			this.notificationForm.declarationContents = '';
		},
		// 上传文件成功后
		uploadSuccess1(res, file, fileList) {
			if (file.response.code == 200) {
				this.notificationForm.declarationContents = res.data[0];
				this.declarationContents = {
					name: file.name,
					fileId: file.response.data[0]
				};
			}
		},
		beforeAvatarUpload1(file) {
			console.log('上传文件之前',file);
			let regexp = /\.(?:doc|docx)$/i
			const isWord = regexp.test(file.name)
			if (!isWord) {
				this.$message.error('请上传word文档！');
			}
			return isWord;
		},
		beforeAvatarUpload2(file) {
			console.log('上传文件之前',file);
			let regexp = /\.(?:doc|docx)$/i
			// const isWord = file.type === 'application/msword' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
			const isWord = regexp.test(file.name)
			if (!isWord) {
				this.$message.error('请上传word文档！');
			}
			return isWord;
		},
		beforeRemove2(file, fileList) {
			this.notificationForm.anonymousReview = '';
		},
		// 上传文件成功后
		uploadSuccess2(res, file, fileList) {
			if (file.response.code == 200) {
				this.notificationForm.anonymousReview = res.data[0];
				this.anonymousReview = {
					name: file.name,
					fileId: file.response.data[0]
				};
			}
		},
		//删除文件
		delFile1() {
			this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.$refs.upload1.clearFiles();
					this.notificationForm.declarationContents = '';
					this.declarationContents = {};
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		//删除文件
		delFile2() {
			this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.$refs.upload2.clearFiles();
					this.notificationForm.anonymousReview = '';
					this.anonymousReview = {};
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		preview1() {
			window.open(`${this.uploadUrl}/upload/downloadPdf/${this.declarationContents.fileId}`, '_blank');
		},
		preview2() {
			window.open(`${this.uploadUrl}/upload/downloadPdf/${this.anonymousReview.fileId}`, '_blank');
		}
	}
};
</script>

<style scoped lang="scss">
::v-deep .el-upload {
	display: flex;
}
.el-upload__tip {
	color: red;
}
.uploaded-file {
	color: #409eff;
	position: relative;
	margin-left: 20px;
	height: 30px;
	line-height: 30px;
	width: 50%;
	padding: 0 20px;
	border: 1px dotted #666;
	cursor: pointer;
	.icon {
		cursor: pointer;
		position: absolute;
		font-size: 24px;
		top: -10px;
		right: -10px;
		color: orangered;
	}
}
</style>
